import { isSameDay, isSameMonth, isValid } from 'date-fns';
import { format } from 'date-fns/fp';

import { EDateFormat } from 'detailsv2/structure';
// eslint-disable-next-line import/named,import/no-duplicates
import { apply, is, map, of, pipe, unless, when } from 'ramda';
// eslint-disable-next-line import/no-duplicates
import { isDefined } from 'utils/ramda';

const getFormatMonthDayFn = (dateFormat) => (dateFormat === EDateFormat.DMY ? format('d MMMM') : format('MMMM d'));
const toDate = (date) => new Date(date);

const _formatRangeDates = (dateFormat) => (fromDate, toDate) => {
  if (!isValid(fromDate) && !isValid(toDate)) return;

  const formatMonthDay = getFormatMonthDayFn(dateFormat);

  if (!isValid(fromDate)) return `to ${formatMonthDay(toDate)}`;
  if (!isValid(toDate) || isSameDay(fromDate, toDate)) return formatMonthDay(fromDate);

  if (isSameMonth(fromDate, toDate)) return `${formatMonthDay(fromDate)} - ${format('d', toDate)}`;

  return `${formatMonthDay(fromDate)} - ${formatMonthDay(toDate)}`;
};

export const parseTime = when(isDefined, toDate);

export const formatRangeDates = (dateFormat) =>
  pipe(unless(is(Array), of), map(parseTime), apply(_formatRangeDates(dateFormat)));
